import { render, staticRenderFns } from "./expend.vue?vue&type=template&id=72b734ce&scoped=true"
import script from "./expend.vue?vue&type=script&lang=js"
export * from "./expend.vue?vue&type=script&lang=js"
import style0 from "./expend.vue?vue&type=style&index=0&id=72b734ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b734ce",
  null
  
)

export default component.exports